import React from "react";
import { Container } from 'react-bootstrap';

import { Link } from 'react-router-dom';

import WOW from "wowjs";

class Hero extends React.Component {

	componentDidMount() {
    	new WOW.WOW().init();
  	}
  	render() {
		return (
			<div className="HereoBanner web">
			    <div className="Banner_Content">
					<Container fluid>
						<h2 className="pagehead-title wow fadeInUp">WORDPRESS <br /> DEVELOPMENT</h2>
						<div className="red-border"> </div>
						<p>digiPanda is an offshore Wordpress development company in India that helps organizations in implementing end-to-end ecommerce web solutions for their businesses using the Wordpress platform.</p>
						<Link to="/contact-us" className="red-btn"> GET FREE ESTIMATION </Link>
					</Container>
				</div>
			</div>
		);
	}
};

export default Hero;
